// vue
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// 引入页面
import Read from "@/pages/read"

// 构建路由
const router = new Router({
  routes: [
	// 阅读单篇文章
	{
		path: '/article/:id(\\d+)',
		name: 'article',
		component: Read
	},
	// 随机阅读
	{
		path: '/',
		name: 'read',
		component: Read
	}
  ]
});

// 输出路由
export default router;
